
import DevelopmentAccessor from "../../Portal/Accessor/Development/DevelopmentAccessor";
import DevelopmentDetail from "../../Portal/Accessor/Development/DevelopmentDetail";
const AccessorDevelopmentRouters = [
    {
      path: "DevelopmentAssessor/Detail/:developmentId",
      exact: true,
      requireAuth: true,
      element: <DevelopmentDetail></DevelopmentDetail>,
      title: "Development | AccuRate Enterprise",
    },
    {
      path: "DevelopmentAssessor",
      exact: true,
      requireAuth: true,
      element: <DevelopmentAccessor />,
    },
  ];
export default AccessorDevelopmentRouters;
